import axios from "axios";

export function createScanApi(apiUrl) {
    const baseUrl = `${apiUrl.replace(/\/+$/, "")}/`;
    const config = (signal) => ({
        withCredentials: true,
        signal,
        headers: {
            Accept: "application/json",
        },
    });

    return {
        async list(signal) {
            const { data } = await axios.get(`${baseUrl}scan`, config(signal));
            if (!Array.isArray(data?.scans)) throw new Error("Invalid scan list");
            return data;
        },
        async detail(scan, signal) {
            const reference = scan.report_url || scan.detail_url;
            const reportUrl = reference
                ? new URL(reference, baseUrl).href
                : `${baseUrl}scan/${encodeURIComponent(scan.scan_id)}`;
            if (new URL(reportUrl).origin !== new URL(baseUrl).origin) throw new Error("Invalid report URL");
            const { data } = await axios.get(reportUrl, {
                ...config(signal),
                ...(!reference && {
                    params: { date_folder: scan.date_folder },
                }),
            });
            if (!data?.scan) throw new Error("Invalid scan detail");
            return data.scan;
        },
        async file(file, dateFolder, { download = false, signal } = {}) {
            // Extract only the file identifiers: always send credentials to our API.
            const viewUrl = file.view_url ? new URL(file.view_url, baseUrl) : null;
            const filename = viewUrl?.searchParams.get("filename") || file.filename;
            const date_folder = viewUrl?.searchParams.get("date_folder") || dateFolder;
            if (!filename || !date_folder) throw new Error("Invalid scan file");
            const { data } = await axios.get(`${baseUrl}scan/file`, {
                ...config(signal),
                params: { filename, date_folder, ...(download ? { download: 1 } : {}) },
                responseType: "blob",
            });
            return { blob: data, filename };
        },
    };
}
